export default function throttle (callback, interval = 100) {
  let timeout;

  return function () {
    if (timeout) return;

    timeout = setTimeout(function () {
      clearTimeout(timeout);
      timeout = null;
    }, interval);

    callback.apply(null, arguments);
  };
}
